import { ForgotPasswordForm } from '@/components/forms/ForgotPasswordForm'

export default function ForgotPasswordPage() {
  return <ForgotPasswordForm />
}

